import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const AdminVerifyReviewer = () => {
  const [reviewers, setReviewers] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);             // ✅ added state
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [selectedPdfUrl, setSelectedPdfUrl] = useState(null);
  const API = process.env.REACT_APP_API_BASE_URL;

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    toolbarPlugin: {
      toolbarSlot: slots => {
        const { Download, ...rest } = slots;
        return rest;
      },
    },
  });

  useEffect(() => {
    fetchReviewers();
  }, []);

  const fetchReviewers = async () => {
    try {
      const res = await axios.get(`${API}/api/admin/unapproved-rev`);
      setReviewers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleCheckbox = id => {
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  const handleApprove = async () => {
    try {
      const res = await axios.put(`${API}/api/reviewer/approve`, {
        reviewerIDs: selectedIds
      });
      alert(res.data.message);
      setSelectedIds([]);
      fetchReviewers();
    } catch (err) {
      console.error(err);
      alert('Error approving reviewers');
    }
  };

  const openPdfInModal = fileName => {
    setSelectedPdfUrl(`${API}/uploads/agreement/${fileName}`);
    setShowPdfModal(true);
  };

  const closePdfModal = () => {
    setShowPdfModal(false);
    setSelectedPdfUrl(null);
  };

  return (
    <div className="container mt-4">
      <h3 className="text-center mb-4 text-primary">Verify Reviewers</h3>

      {reviewers.length === 0 ? (
        <div className="alert alert-info fw-bold text-center mb-3 rounded shadow-sm" role="alert">
          No unapproved reviewers found.
        </div>
      ) : (
        <>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Select</th>
                <th>ReviewerID</th>
                <th>Name</th>
                <th>User Name</th>
                <th>Email</th>
                <th>Contact</th>
                <th>Address</th>
                <th>View ID</th>
              </tr>
            </thead>
            <tbody>
              {reviewers.map(r => (
                <tr key={r.ReviewerID}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(r.ReviewerID)}
                      onChange={() => handleCheckbox(r.ReviewerID)}
                    />
                  </td>
                  <td>{r.ReviewerID}</td>
                  <td>{r.ReviewerName}</td>
                  <td>{r.UserName}</td>
                  <td>{r.EmailID}</td>
                  <td>{r.ContactNumber}</td>
                  <td>{r.Address}</td>
                  <td>
                    {r.AgreementFile && r.AgreementFile.endsWith('.pdf') ? (
                      <Button
                        variant="info"
                        size="sm"               // optional
                        onClick={() => openPdfInModal(r.AgreementFile)}
                      >
                        View PDF
                      </Button>

                    ) : (
                      <span className="text-warning">No PDF</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <Button
            variant="success"
            className="mb-2"
            onClick={handleApprove}
            disabled={selectedIds.length === 0}
          >
            Approve Selected
          </Button>
        </>
      )}

      {/* PDF Viewer Modal */}
      <Modal
        show={showPdfModal}
        onHide={closePdfModal}
        size="xl"
        dialogClassName="modal-90w"
        aria-labelledby="pdf-modal-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="pdf-modal-title">Reviewer ID Document</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: '80vh' }}>
          {selectedPdfUrl && (
            <Worker workerUrl="/pdf.worker.min.js">
              <Viewer fileUrl={selectedPdfUrl} plugins={[defaultLayoutPluginInstance]} />
            </Worker>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AdminVerifyReviewer;
